// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsWebMessengerConfigurationVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantProductRelationsVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantProductRelationsRelationTypesItem = {
    Undefined: 'Undefined',
    Related: 'Related',
    RecentlyViewed: 'RecentlyViewed',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantDigitalPromotionsChannel = {
    Website: 'Website',
    MV7: 'MV7',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantDigitalPromotionsPromotionTypesItem = {
    BestOffers: 'BestOffers',
    WhatsNew: 'WhatsNew',
    Hero: 'Hero',
    Campaign: 'Campaign',
    Category: 'Category',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantProductsReplacementsVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsMv7ModulesProductsPricesRepositoryProductsPricesVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantProductsManufacturersVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsMv7ModulesProductsLabelsRepositoryProductsLabelsVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantProductsLabelsVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantProductsLabelsProductLabelDomainsItem = {
    Undefined: 'Undefined',
    PPA: 'PPA',
    Deal: 'Deal',
    Shopping: 'Shopping',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantProductsIngredientsVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantProductsExpectedInboundsVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsMv7ModulesProductsRepositoryProductsHashCodesVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsMv7ModulesProductsRepositoryProductsVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantDeprecatedProductVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantProductBundlesVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantProductBundleVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsProductBoxVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantConceptPriceVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantProductPriceVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantConceptPermissionVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantProductPermissionVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsOlapicConfigurationOlapicType = {
    Category: 'Category',
    FrontPage: 'FrontPage',
    Gallery: 'Gallery',
    ProductDetails: 'ProductDetails',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsNavigationNavigationVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsFrontPageVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsFrontPageBenefitBannerVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantConceptsFormattedPricesVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantProductsFormattedPricesVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsFooterVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsBannerFeedbackBenefitBannersBannerTypesItem = {
    ShareAndEarn: 'ShareAndEarn',
    Cashback: 'Cashback',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantEditorialArticlesArticleType = {
    BeautyEdit: 'BeautyEdit',
    RelatedToProduct: 'RelatedToProduct',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsEditorialEditorialPagesChannel = {
    Web: 'Web',
    Mobile: 'Mobile',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantCustomerConfirmationMetadataConfirmationContextType = {
    Profile: 'Profile',
    SelfRegistration: 'SelfRegistration',
    SponsorRegistration: 'SponsorRegistration',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsMv7ModulesConceptsLabelsRepositoryConceptsLabelsVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsMv7ModulesConceptsRepositoryConceptsHashCodesVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsMv7ModulesConceptsRepositoryConceptsVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantDeprecatedConceptVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantConceptLabelsVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantConceptLabelsConceptLabelDomainsItem = {
    Undefined: 'Undefined',
    PPA: 'PPA',
    Deal: 'Deal',
    Shopping: 'Shopping',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsChatBotPageMetadataVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsCatalogueOverviewVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantRewardShopConfigurationsCustomerCategory = {
    Anonymous: 'Anonymous',
    Consultant: 'Consultant',
    EndConsumer: 'EndConsumer',
    Invitation: 'Invitation',
    Employee: 'Employee',
    EndCustomer: 'EndCustomer',
    Other: 'Other',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantConceptAvailabilityVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantProductAvailabilityVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsAdverseReactionProductsPartialSetCategoriesItem = {
    Unknown: 'Unknown',
    Cosmetics: 'Cosmetics',
    AddOns: 'AddOns',
    Jewellery: 'Jewellery',
    Other: 'Other',
    PrintingMaterial: 'PrintingMaterial',
    Wellness: 'Wellness',
    Fee: 'Fee',
    DemoProduct: 'DemoProduct',
    Packaging: 'Packaging',
    Training: 'Training',
    RecruitmentGifts: 'RecruitmentGifts',
    NonFinancial: 'NonFinancial',
    OtherSample: 'OtherSample',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsAdverseReactionProductsPartialSetItemType = {
    Bundle: 'Bundle',
    Composite: 'Composite',
    Fee: 'Fee',
    Product: 'Product',
    Sample: 'Sample',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticTermsTermHtmlDtoTermsSource = {
    Sitecore: 'Sitecore',
    OneTrust: 'OneTrust',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticSubscriptionsSubscriptionTypeDtoCategory = {
    Wellness: 'Wellness',
    LifePlus: 'LifePlus',
    HairCare: 'HairCare',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticSocialMediaLinksSocialMediaLinkType = {
    Facebook: 'Facebook',
    VKontakte: 'VKontakte',
    Twitter: 'Twitter',
    YouTube: 'YouTube',
    Instagram: 'Instagram',
    Pinterest: 'Pinterest',
    Odnoklassniki: 'Odnoklassniki',
    Weibo: 'Weibo',
    QQ: 'QQ',
    Youku: 'Youku',
    Line: 'Line',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticShoppingOrderTrackingsDtoCurrentStatus = {
    Unknown: 'Unknown',
    Create: 'Create',
    Cancel: 'Cancel',
    Print: 'Print',
    Pick: 'Pick',
    Ship: 'Ship',
    CourierTakeover: 'CourierTakeover',
    TakenByCourier: 'TakenByCourier',
    OutForDelivery: 'OutForDelivery',
    ReturnedToSender: 'ReturnedToSender',
    ToBeReturnedToSender: 'ToBeReturnedToSender',
    ReadyForPickup: 'ReadyForPickup',
    PickedUpBy: 'PickedUpBy',
    HandoverFailed: 'HandoverFailed',
    CourierHandover: 'CourierHandover',
    Deliver: 'Deliver',
    EstimatedDelivery: 'EstimatedDelivery',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticShoppingOrderTrackingStepDtoStatus = {
    Unknown: 'Unknown',
    Create: 'Create',
    Cancel: 'Cancel',
    Print: 'Print',
    Pick: 'Pick',
    Ship: 'Ship',
    CourierTakeover: 'CourierTakeover',
    TakenByCourier: 'TakenByCourier',
    OutForDelivery: 'OutForDelivery',
    ReturnedToSender: 'ReturnedToSender',
    ToBeReturnedToSender: 'ToBeReturnedToSender',
    ReadyForPickup: 'ReadyForPickup',
    PickedUpBy: 'PickedUpBy',
    HandoverFailed: 'HandoverFailed',
    CourierHandover: 'CourierHandover',
    Deliver: 'Deliver',
    EstimatedDelivery: 'EstimatedDelivery',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticSharedLinkDtoType = {
    Product: 'Product',
    Brand: 'Brand',
    PLpage: 'PLpage',
    EditorialArticle: 'EditorialArticle',
    Invite: 'Invite',
    Custom: 'Custom',
    Category: 'Category',
    NewProducts: 'NewProducts',
    Catalogue: 'Catalogue',
    Campaign: 'Campaign',
    NovageSkincareAdvisor: 'NovageSkincareAdvisor',
    EditorialCampaign: 'EditorialCampaign',
    Ingredient: 'Ingredient',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticSampleSampleDtoType = {
    Sample: 'Sample',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticProductsRelationRelationType = {
    Undefined: 'Undefined',
    Related: 'Related',
    RecentlyViewed: 'RecentlyViewed',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticProductsProductLabelsDtoProductLabelDomain = {
    Undefined: 'Undefined',
    PPA: 'PPA',
    Deal: 'Deal',
    Shopping: 'Shopping',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticProductsProductLabelsDtoProductsLabelsCollectionItem = {
    None: 'None',
    NoLongerForSale: 'NoLongerForSale',
    SoldOut: 'SoldOut',
    SaleLimitation: 'SaleLimitation',
    OutOfStock: 'OutOfStock',
    NotSoldOnline: 'NotSoldOnline',
    ComingSoon: 'ComingSoon',
    LowStock: 'LowStock',
    Offer: 'Offer',
    New: 'New',
    LastChance: 'LastChance',
    UntilStockLasts: 'UntilStockLasts',
    ValueSet: 'ValueSet',
    Hidden: 'Hidden',
    SuperDeal: 'SuperDeal',
    AddToBasketVisible: 'AddToBasketVisible',
    BackInStock: 'BackInStock',
    CanBeReserved: 'CanBeReserved',
    ShowBackOrder: 'ShowBackOrder',
    NewEdition: 'NewEdition',
    NewEditionAvailable: 'NewEditionAvailable',
    CanBeSubscribed: 'CanBeSubscribed',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticProductsProductDtoItemCategory = {
    Unknown: 'Unknown',
    Cosmetics: 'Cosmetics',
    AddOns: 'AddOns',
    Jewellery: 'Jewellery',
    Other: 'Other',
    PrintingMaterial: 'PrintingMaterial',
    Wellness: 'Wellness',
    Fee: 'Fee',
    DemoProduct: 'DemoProduct',
    Packaging: 'Packaging',
    Training: 'Training',
    RecruitmentGifts: 'RecruitmentGifts',
    NonFinancial: 'NonFinancial',
    OtherSample: 'OtherSample',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticProductsProductDtoProductType = {
    Product: 'Product',
    Bundle: 'Bundle',
    Sample: 'Sample',
    Fee: 'Fee',
    Composite: 'Composite',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticOlapicOlapicConfigurationDtoType = {
    Category: 'Category',
    FrontPage: 'FrontPage',
    Gallery: 'Gallery',
    ProductDetails: 'ProductDetails',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticNavigationNavigationItemDtoType = {
    TopNavigation: 'TopNavigation',
    ShopSection: 'ShopSection',
    AboutTiles: 'AboutTiles',
    JoinTiles: 'JoinTiles',
    InspirationTiles: 'InspirationTiles',
    Footer: 'Footer',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticNavigationNavigationItemDtoLinkType = {
    None: 'None',
    MenuTiles: 'MenuTiles',
    TopNavigation: 'TopNavigation',
    FocusPage: 'FocusPage',
    Category: 'Category',
    SubCategory: 'SubCategory',
    Segment: 'Segment',
    OutletShop: 'OutletShop',
    JoinRewards: 'JoinRewards',
    RewardsShop: 'RewardsShop',
    SampleShop: 'SampleShop',
    Catalogue: 'Catalogue',
    DigitalCatalogueCurrent: 'DigitalCatalogueCurrent',
    DigitalCatalogueNext: 'DigitalCatalogueNext',
    Catalogues: 'Catalogues',
    PopularProducts: 'PopularProducts',
    PopularBrands: 'PopularBrands',
    PopularBrand: 'PopularBrand',
    PopularLookbook: 'PopularLookbook',
    KeyIngredients: 'KeyIngredients',
    WhatsNewInCategory: 'WhatsNewInCategory',
    New: 'New',
    AllCategory: 'AllCategory',
    SupportCenter: 'SupportCenter',
    IDontKnowYet: 'IDontKnowYet',
    FooterColumn: 'FooterColumn',
    FooterColumnItem: 'FooterColumnItem',
    Bottom: 'Bottom',
    BottomCopyright: 'BottomCopyright',
    BottomLinks: 'BottomLinks',
    PaymentMethods: 'PaymentMethods',
    PaymentMethod: 'PaymentMethod',
    QRTR: 'QRTR',
    OurApps: 'OurApps',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticMobileOfficeModulesVisibilityDtoEarningsOnDashboardVisitorSegmentsItem = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticMobileAppsMobileAppTypeDtoType = {
    None: 'None',
    ToSell: 'ToSell',
    ToShop: 'ToShop',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticManagerSeminarParamsMinDiscountRateQualificationDtoDiscountRateLevel = {
    LevelBasic: 'LevelBasic',
    Level10: 'Level10',
    Level20: 'Level20',
    Level30: 'Level30',
    Level40: 'Level40',
    Level50: 'Level50',
    Level60: 'Level60',
    LevelMax: 'LevelMax',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticMV7ProductListingsProductListingPromoItemDtoType = {
    Product: 'Product',
    PromoBanner: 'PromoBanner',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticLanguagesLanguageType = {
    Default: 'Default',
    Alternative: 'Alternative',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticEditorialArticlesEditorialArticleDtoArticleType = {
    BeautyEdit: 'BeautyEdit',
    RelatedToProduct: 'RelatedToProduct',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticECatalogueStructureImageDtoType = {
    Unknown: 'Unknown',
    Thumb: 'Thumb',
    Normal: 'Normal',
    Zoom: 'Zoom',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticDocumentsDocumentTypeDtoDocumentCategory = {
    General: 'General',
    CreditRequest: 'CreditRequest',
    Personal: 'Personal',
    Claim: 'Claim',
    Legal: 'Legal',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticDocumentsDocumentTypeDtoDocumentTag = {
    NotSpecified: 'NotSpecified',
    IdentityCard: 'IdentityCard',
    Passport: 'Passport',
    ProfileImage: 'ProfileImage',
    DamageParcel: 'DamageParcel',
    DamageCover: 'DamageCover',
    BankAccount: 'BankAccount',
    WellnessSellingApplication: 'WellnessSellingApplication',
    WellnessSellingCertificate: 'WellnessSellingCertificate',
    Caf: 'Caf',
    Commitment: 'Commitment',
    Annex: 'Annex',
    DamagedProduct: 'DamagedProduct',
    ExportedFile: 'ExportedFile',
    Custom: 'Custom',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticDigitalPromotionsCurrentPromotionDtoChannel = {
    Website: 'Website',
    MV7: 'MV7',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticDigitalPromotionsCurrentPromotionDtoPromotionType = {
    BestOffers: 'BestOffers',
    WhatsNew: 'WhatsNew',
    Hero: 'Hero',
    Campaign: 'Campaign',
    Category: 'Category',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticDeprecatedProductDtoProductType = {
    Product: 'Product',
    Bundle: 'Bundle',
    Sample: 'Sample',
    Fee: 'Fee',
    Composite: 'Composite',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticCustomersMetadataAddressSearchMetadataDtoAllowedSearchResultsItem = {
    Market: 'Market',
    Country: 'Country',
    Region: 'Region',
    Province: 'Province',
    District: 'District',
    Area: 'Area',
    City: 'City',
    Locality: 'Locality',
    Street: 'Street',
    ZipCode: 'ZipCode',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticCustomerRegistrationsMetadataRegistrationSponsorDetailsMetadataDtoPreselectedSponsorSelectionMethod = {
    ManualInput: 'ManualInput',
    SponsorLocator: 'SponsorLocator',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticCustomerExternalProfilesMetadataExternalProfilesMetadataDtoAvailableOptionsItem = {
    Google: 'Google',
    Facebook: 'Facebook',
    VKontakte: 'VKontakte',
    ActiveDirectory: 'ActiveDirectory',
    WeChat: 'WeChat',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticConceptsConceptLabelsDtoConceptLabelDomain = {
    Undefined: 'Undefined',
    PPA: 'PPA',
    Deal: 'Deal',
    Shopping: 'Shopping',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticConceptsConceptLabelsDtoConceptLabelsCollectionItem = {
    None: 'None',
    NoLongerForSale: 'NoLongerForSale',
    SoldOut: 'SoldOut',
    SaleLimitation: 'SaleLimitation',
    OutOfStock: 'OutOfStock',
    NotSoldOnline: 'NotSoldOnline',
    ComingSoon: 'ComingSoon',
    LowStock: 'LowStock',
    Offer: 'Offer',
    New: 'New',
    LastChance: 'LastChance',
    UntilStockLasts: 'UntilStockLasts',
    ValueSet: 'ValueSet',
    Hidden: 'Hidden',
    SuperDeal: 'SuperDeal',
    AddToBasketVisible: 'AddToBasketVisible',
    BackInStock: 'BackInStock',
    CanBeReserved: 'CanBeReserved',
    ShowBackOrder: 'ShowBackOrder',
    NewEdition: 'NewEdition',
    NewEditionAvailable: 'NewEditionAvailable',
    CanBeSubscribed: 'CanBeSubscribed',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticCampaignsRewardShopConfigurationDtoCustomerCategory = {
    Anonymous: 'Anonymous',
    Consultant: 'Consultant',
    EndConsumer: 'EndConsumer',
    Invitation: 'Invitation',
    Employee: 'Employee',
    EndCustomer: 'EndCustomer',
    Other: 'Other',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticBonusesCommissionPlanTypeDtoCommissionPlanType = {
    SuccessPlan: 'SuccessPlan',
    MatureMarkets: 'MatureMarkets',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsNewsletterSubsciptionConfigurationResponseMessageType = {
    Unknown: 'Unknown',
    New: 'New',
    Subscribed: 'Subscribed',
    Pending: 'Pending',
    Unsubscribed: 'Unsubscribed',
    Cleaned: 'Cleaned',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsFrontpageV3VideoDtoType = {
    None: 'None',
    Mp4: 'Mp4',
    Youtube: 'Youtube',
    Youku: 'Youku',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsFrontpageV3NotificationBannerDtoMessageTheme = {
    Black: 'Black',
    Grey: 'Grey',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsFooterBffSocialMediaLinkDtoType = {
    Facebook: 'Facebook',
    VKontakte: 'VKontakte',
    Twitter: 'Twitter',
    YouTube: 'YouTube',
    Instagram: 'Instagram',
    Pinterest: 'Pinterest',
    Odnoklassniki: 'Odnoklassniki',
    Weibo: 'Weibo',
    QQ: 'QQ',
    Youku: 'Youku',
    Line: 'Line',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsFooterBffResponseMessageDtoType = {
    Unknown: 'Unknown',
    New: 'New',
    Subscribed: 'Subscribed',
    Pending: 'Pending',
    Unsubscribed: 'Unsubscribed',
    Cleaned: 'Cleaned',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsFooterBffNavigationItemDtoLinkType = {
    None: 'None',
    MenuTiles: 'MenuTiles',
    TopNavigation: 'TopNavigation',
    FocusPage: 'FocusPage',
    Category: 'Category',
    SubCategory: 'SubCategory',
    Segment: 'Segment',
    OutletShop: 'OutletShop',
    JoinRewards: 'JoinRewards',
    RewardsShop: 'RewardsShop',
    SampleShop: 'SampleShop',
    Catalogue: 'Catalogue',
    DigitalCatalogueCurrent: 'DigitalCatalogueCurrent',
    DigitalCatalogueNext: 'DigitalCatalogueNext',
    Catalogues: 'Catalogues',
    PopularProducts: 'PopularProducts',
    PopularBrands: 'PopularBrands',
    PopularBrand: 'PopularBrand',
    PopularLookbook: 'PopularLookbook',
    KeyIngredients: 'KeyIngredients',
    WhatsNewInCategory: 'WhatsNewInCategory',
    New: 'New',
    AllCategory: 'AllCategory',
    SupportCenter: 'SupportCenter',
    IDontKnowYet: 'IDontKnowYet',
    FooterColumn: 'FooterColumn',
    FooterColumnItem: 'FooterColumnItem',
    Bottom: 'Bottom',
    BottomCopyright: 'BottomCopyright',
    BottomLinks: 'BottomLinks',
    PaymentMethods: 'PaymentMethods',
    PaymentMethod: 'PaymentMethod',
    QRTR: 'QRTR',
    OurApps: 'OurApps',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsFooterBffNavigationDtoNavigationType = {
    TopNavigation: 'TopNavigation',
    ShopSection: 'ShopSection',
    AboutTiles: 'AboutTiles',
    JoinTiles: 'JoinTiles',
    InspirationTiles: 'InspirationTiles',
    Footer: 'Footer',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsFooterBffMobileAppMobileAppTypeDtoType = {
    None: 'None',
    ToSell: 'ToSell',
    ToShop: 'ToShop',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsFooterBffLanguageDtoType = {
    Default: 'Default',
    Alternative: 'Alternative',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialProductListingProductDtoPosition = {
    Position1: 'Position1',
    Position2: 'Position2',
    Position3: 'Position3',
    Position4: 'Position4',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialProductListingBannerDtoSize = {
    Size1: 'Size1',
    Size2: 'Size2',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialProductListingBannerDtoPosition = {
    Position1: 'Position1',
    Position2: 'Position2',
    Position3: 'Position3',
    Position4: 'Position4',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialOlapicDtoType = {
    Category: 'Category',
    FrontPage: 'FrontPage',
    Gallery: 'Gallery',
    ProductDetails: 'ProductDetails',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialMixedPlpContentOrderDefinitionDtoOrderBy = {
    Recommended: 'Recommended',
    Latest: 'Latest',
    HighestRating: 'HighestRating',
    LowestPrice: 'LowestPrice',
    HighestPrice: 'HighestPrice',
    HighestDiscount: 'HighestDiscount',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialMixedPlpContentDtoListingType = {
    Manual: 'Manual',
    Category: 'Category',
    Brand: 'Brand',
    SampleShop: 'SampleShop',
    Outlet: 'Outlet',
    New: 'New',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialLandingPageDtoBackgroundStorybookColor = {
    Undefined: 'Undefined',
    TextPrimary: 'TextPrimary',
    TextSecondary: 'TextSecondary',
    DefaultContrastText: 'DefaultContrastText',
    SecondaryMain: 'SecondaryMain',
    Grey50: 'Grey50',
    Brown300: 'Brown300',
    Purple200: 'Purple200',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialLandingPageDtoHeadlineStorybookColor = {
    Undefined: 'Undefined',
    TextPrimary: 'TextPrimary',
    TextSecondary: 'TextSecondary',
    DefaultContrastText: 'DefaultContrastText',
    SecondaryMain: 'SecondaryMain',
    Grey50: 'Grey50',
    Brown300: 'Brown300',
    Purple200: 'Purple200',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialLandingPageDtoTitleColor = {
    Black: 'Black',
    DarkGrey: 'DarkGrey',
    White: 'White',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialHeaderDtoHeadlineStorybookColor = {
    Undefined: 'Undefined',
    TextPrimary: 'TextPrimary',
    TextSecondary: 'TextSecondary',
    DefaultContrastText: 'DefaultContrastText',
    SecondaryMain: 'SecondaryMain',
    Grey50: 'Grey50',
    Brown300: 'Brown300',
    Purple200: 'Purple200',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialHeaderDtoBackgroundStorybookColor = {
    Undefined: 'Undefined',
    TextPrimary: 'TextPrimary',
    TextSecondary: 'TextSecondary',
    DefaultContrastText: 'DefaultContrastText',
    SecondaryMain: 'SecondaryMain',
    Grey50: 'Grey50',
    Brown300: 'Brown300',
    Purple200: 'Purple200',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialEditorialBannerModuleDtoBackgroundType = {
    None: 'None',
    Image: 'Image',
    Video: 'Video',
    Color: 'Color',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialEditorialBannerDtoLayout = {
    ThreeMediaRightBottomText: 'ThreeMediaRightBottomText',
    Quote: 'Quote',
    ParagraphText: 'ParagraphText',
    TwoMedia: 'TwoMedia',
    Headline: 'Headline',
    OneMediaParagraphText: 'OneMediaParagraphText',
    Video: 'Video',
    OneMediaOverlayLeftText: 'OneMediaOverlayLeftText',
    OneMediaOverlayRightText: 'OneMediaOverlayRightText',
    OneMediaCenterBottomText: 'OneMediaCenterBottomText',
    TwoMediaRightTopText: 'TwoMediaRightTopText',
    FourMedia: 'FourMedia',
    OneMediaProductPromo: 'OneMediaProductPromo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialEditorialBannerContentDtoVerticalAlignment = {
    Undefined: 'Undefined',
    Top: 'Top',
    Middle: 'Middle',
    Bottom: 'Bottom',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialEditorialBannerContentDtoTitleColor = {
    Black: 'Black',
    DarkGrey: 'DarkGrey',
    White: 'White',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialContentDtoType = {
    Header: 'Header',
    Banner: 'Banner',
    Olapic: 'Olapic',
    ArticleCarousel: 'ArticleCarousel',
    ProductBoxCarousel: 'ProductBoxCarousel',
    EditorialCarousel: 'EditorialCarousel',
    MixedPlpContent: 'MixedPlpContent',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialBackgroundVideoDtoType = {
    Mp4: 'Mp4',
    Youtube: 'Youtube',
    Youku: 'Youku',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialBackgroundColorDtoType = {
    White: 'White',
    Brown: 'Brown',
    Green: 'Green',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsCatalogueOverviewCatalogueDtoCatalogueType = {
    None: 'None',
    DigitalCurrent: 'DigitalCurrent',
    DigitalNext: 'DigitalNext',
    LocalCustom: 'LocalCustom',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsCatalogueOverviewCataloguMetadataDtoProviderType = {
    None: 'None',
    Online: 'Online',
    IPaper: 'IPaper',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsBannersFeedbackBenefitBannerDtoBannerType = {
    ShareAndEarn: 'ShareAndEarn',
    Cashback: 'Cashback',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsAdverseReactionProductAdrDtoItemCategory = {
    Unknown: 'Unknown',
    Cosmetics: 'Cosmetics',
    AddOns: 'AddOns',
    Jewellery: 'Jewellery',
    Other: 'Other',
    PrintingMaterial: 'PrintingMaterial',
    Wellness: 'Wellness',
    Fee: 'Fee',
    DemoProduct: 'DemoProduct',
    Packaging: 'Packaging',
    Training: 'Training',
    RecruitmentGifts: 'RecruitmentGifts',
    NonFinancial: 'NonFinancial',
    OtherSample: 'OtherSample',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsAdverseReactionProductAdrDtoItemType = {
    Bundle: 'Bundle',
    Composite: 'Composite',
    Fee: 'Fee',
    Product: 'Product',
    Sample: 'Sample',
};

//# sourceMappingURL=api.schemas.js.map
